import { render, staticRenderFns } from "./EmptyCalendar.vue?vue&type=template&id=50c703aa&"
import script from "./EmptyCalendar.vue?vue&type=script&lang=js&"
export * from "./EmptyCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50c703aa')) {
      api.createRecord('50c703aa', component.options)
    } else {
      api.reload('50c703aa', component.options)
    }
    module.hot.accept("./EmptyCalendar.vue?vue&type=template&id=50c703aa&", function () {
      api.rerender('50c703aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmptyCalendar.vue"
export default component.exports